<template>
  <div>
    <component-header
      title="Edit Tenant"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/tenant')"
    />
 
    <b-card>
      <div>
        <h3 class="mx-3" style="color: var(--primary)">Tenant Information</h3>
         <b-row class="mb-3">
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">Company Name:</label>
              <b-form-input
                inputType="text"
                inputId="name"
                placeholder="Enter Company Name"
                v-model="currentUser.company.name"
                class="mt-1"
              />
            </div>
            <div class="mx-3 mb-3">
              <label class="h5-text">Email:</label>
              <b-form-input
                inputType="text"
                inputId="Email"
                placeholder="Enter Email"
                v-model="currentUser.authentication.email"
                class="mt-1"
              />
            </div>
          </b-col>
           <b-col md="4">
            <div class="mx-3 mb-3" >
              <label class="h5-text">Phone Number:</label>
              <c-tel-input
                v-model="currentUser.authentication.phone"
                :defaultInput="currentUser.authentication.phone"
                class="mt-1 w-100 phone-input "
              />
            </div>
            <div class="mx-3 mb-3">
              <label class="h5-text">Password:</label>
              <b-form-input
                v-model="password"
                placeholder="Enter password"
                class="mt-1"
              />
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">Company Logo:</label>
              <div class="mt-1" style="margin-left: -15px;">
                <single-image
                  height="128px"
                  width="130px"
                  @change="(d) => uploadImage('profilePhoto', d)"
                  :id="'profilePhoto'"
                  :url="currentUser.company.logo"
                  label="Logo"
                />
              </div>
            </div>
          </b-col>
        </b-row>
 
        <hr class="mt-2" style="border-top: 1px dashed var(--primary)" />
        <h3 class="mx-3" style="color: var(--primary)">Tenant Address</h3>
 
        <b-row class="mb-3">
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">Country:</label>
              <b-form-input
                type="text"
                v-model="currentUser.address.country"
                placeholder="Enter Country"
                class="mt-1"
              />
            </div>
            <div class="mx-3 mb-3">
              <label class="h5-text">Street 1:</label>
              <b-form-input
                type="text"
                v-model="currentUser.address.street1"
                placeholder="Enter Street 1"
                class="mt-1"
              />
            </div>
          </b-col>
 
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">State:</label>
              <b-form-input
                type="text"
                v-model="currentUser.address.state"
                placeholder="Enter State"
                class="mt-1"
              />
            </div>
            <div class="mx-3 mb-3">
              <label class="h5-text">Street 2:</label>
              <b-form-input
                type="text"
                v-model="currentUser.address.street2"
                placeholder="Enter Street 2"
                class="mt-1"
              />
            </div>
          </b-col>
 
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">City:</label>
              <b-form-input
                type="text"
                v-model="currentUser.address.city"
                placeholder="Enter City"
                class="mt-1"
              />
            </div>
            <div class="mx-3 mb-3">
              <label class="h5-text">Zipcode:</label>
              <b-form-input
                inputType="number"
                v-model="currentUser.address.zip"
                placeholder="Enter Zipcode"
                class="mt-1"
              />
            </div>
          </b-col>
        </b-row>
 
        <hr class="mt-2" style="border-top: 1px dashed var(--primary)" />
        <h3 class="mx-3" style="color: var(--primary)">Tenant Access</h3>
 
        <b-row class="mb-3">
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">User Name:</label>
              <b-form-input
                type="text"
                v-model="currentUser.authentication.userName"
                placeholder="Enter User Name"
                class="mt-1"
              />
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3 mb-3">
              <label class="h5-text">Category:</label>
              <b-form-input
                readonly
                type="text"
                v-model="currentUser.category"
                placeholder="Enter Access Level"
                class="mt-1"
              />
            </div>
          </b-col>
        </b-row>
       <hr class="mt-2" style="border-top: 1px dashed var(--primary)" />
        <b-button
          size="sm"
          class="mr-2 my-0 main-navigation-button mx-3"
          variant="primary"
          v-b-modal.modal-1
          @click="kycByUser"
        >
          KYC Details
        </b-button>
          <b-modal
          id="modal-1"
          scrollable
          size="lg"
          title="KYC Details"
          centered
          ok-only
        >
          <b-row class="mt-0" v-if="isloading">
            <b-col md="12" class="text-center">
              <h4>Loading....</h4>
            </b-col>
          </b-row>
 
          <b-row class="mt-0 px-5 py-2" v-else-if="kycUser && kycUser.documents">
            <div>
              <kycView :kycDocuments="kycUser.documents" @updateKYC="handleKycUpdate" />
            </div>
          </b-row>
 
          <b-row class="mt-0" v-else>
            <b-col md="12" class="text-center">
              <h4>Kyc Data Not Found</h4>
              <button
                type="button"
                class="btn btn-lg btn-outline-primary ml-3 w-25"
                @click="createKyc()"
              >
                Create KYC
              </button>
            </b-col>
          </b-row>
        </b-modal>
      <div class="text-center mb-5 mt-5">
          <button
            type="button"
            class="btn btn-lg btn-danger ml-3 w-24"
            @click="$router.push('/tenant')"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-lg btn-success ml-3 w-24"
            @click.prevent="handleSubmit"
          >
            Update
          </button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import cTelInput from "@/components/Common/MobileNumberInput";
import ComponentHeader from "@/components/componentNewHeader";
import kycView from "@/components/Tenant/kycView.vue";
import ebSelect from "@/components/FormElements/Select";
import ebButton from "@/components/FormElements/Button";
import { mapGetters } from "vuex";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
export default {
  name: "Edituser",
  components: {
    ebButton,
    SingleImage,
    cTelInput,
    ComponentHeader,
    ebSelect,
    kycView,
  },
  data() {
    return {
      isloading: false,
      password: "",
      currentUser: {
        company: {
          logo: "",
          name: "",
        },
        address: {
          state: "",
          city: "",
          country: "",
          zip: "",
          street1: "",
          street2: "",
        },
        authentication: {
          userName: "",
          phone: "",
          email: "",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      kycUser: "tenant/GetKycByUser",
    }),
    // currentUser() {
    //   return this.currentUser;
    // },
  },
  methods: {
    async viewTenantDetails() {
      await this.$store
        .dispatch("tenant/getTenantDetailByID", this.$route.params.id)
        .then((res) => {
          set: {
            this.currentUser = res.response;
          }
        });
    },
    createKyc() {
      this.$router.push({
        name: "tenantCreateKyc",
        params: { userData: this.currentUser },
      });
    },
    handleKycUpdate(updatedKyc) {
      // Find and update the document in kycUser.documents
      if (this.kycUser && this.kycUser.documents) {
        const index = this.kycUser.documents.findIndex(doc => doc._id === updatedKyc.docId || doc.id === updatedKyc.docId);
        if (index !== -1) {
          const currentDoc = this.kycUser.documents[index];
         
          // Update local state
          this.kycUser.documents.splice(index, 1, updatedKyc);
         
          // Prepare payload matching KYC_v2.vue structure
          const payload = {
            docuementNo: currentDoc.docuementNo,
            frontSideFilePath: updatedKyc.frontSideFilePath,
            backSideFilePath: updatedKyc.backSideFilePath
          };
 
          // Call API with matching structure from KYC_v2.vue
          this.$store.dispatch('tenant/updateKYCByTenant', {
            data: payload,
            userId: this.$route.params.id, // Using the route param as userId
            docId: currentDoc._id || currentDoc.id
          }).then(() => {
            this.$toasted.success("KYC update successful!");
          }).catch((error) => {
            this.$toasted.error("KYC update failed!");
          });
        }
      }
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["agent", "profilePhoto"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.currentUser.company.logo = res.data.fileUrl;
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    handleSubmit() {
      const payload = {
        id: this.$route.params.id,
        data: {
          company: {
            name: this.currentUser.company.name,
            logo: this.currentUser.company.logo,
          },
          authentication: {
            userName: this.currentUser.authentication.userName,
            email: this.currentUser.authentication.email,
            phone: this.currentUser.authentication.phone,
          },
          address: {
            state: this.currentUser.address.state,
            city: this.currentUser.address.city,
            country: this.currentUser.address.country,
            zip: this.currentUser.address.zip,
            street1: this.currentUser.address.street1,
            street2: this.currentUser.address.street2,
          },
        },
      };
      this.$store.dispatch("tenant/updateTenantById", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Tenant updated successfully!!",
          type: "success",
        });
        this.$router.push("/tenant");
      });
    },
    async kycByUser() {
      this.isloading = true;
      await this.$store
        .dispatch("tenant/fetchKYCListByUser", {
          id: this?.$route?.params?.id || "",
        })
        .then((result) => {});
      this.isloading = false;
    },
  },
  mounted: async function () {
    this.loading = true;
    this.viewTenantDetails();
    this.loading = false;
  },
};
</script>
 
<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
 
[col-4="image"] {
  background-color: aliceblue !important;
}
 
[btn-back="primary"] {
  background-color: var(--primary) !important;
  margin: 0px;
  height: 41px;
  color: white;
 }
.footer-bottons-class {
  text-align: center;
  background: var(--primary) !important;
  margin-left: 40%;
}
 
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
 
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
label {
  color: #000 !important;
}
.phone-input ::v-deep input {
  height: 35px;
}
</style>
 
 